import { Box, Grid, Tooltip, Typography } from "@material-ui/core";

import { COLORS } from "../../../theme/colors";

export const Bubble = ({ bubble, bubbleKey, bubbleColors, icons }) => {
  const key = bubble[bubbleKey]?.toLowerCase().replace("-", "_");

  return (
    <Box
      width={bubble.size.width}
      height={bubble.size.width}
      bgcolor={bubbleColors[key]}
      borderRadius="50%"
      position="absolute"
      top={bubble.top}
      left={bubble.left}
      bottom={bubble.bottom}
    >
      <Tooltip title={`${bubble[bubbleKey]} ${Math.round(bubble.percent)}%`} arrow>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ height: "100%" }}
        >
          <Typography
            style={{ color: COLORS.white, fontWeight: "bold", fontSize: bubble.size.numberSize }}
            align="center"
          >
            {bubble.count}
          </Typography>
          {bubble.size.type !== "XS" && (
            <>
              <Box style={{ display: "flex", position: "relative" }}>
                <img src={icons[key]} width={bubble.size.width * 0.3} />
                {key === "5+ stars" ? (
                  <Typography
                    style={{
                      position: "absolute",
                      color: COLORS.white,
                      top: -(bubble.size.numberSize / 2.5),
                      right: -(bubble.size.numberSize / 4),
                      fontSize: bubble.size.numberSize / 2,
                    }}
                  >
                    +
                  </Typography>
                ) : null}
              </Box>
              {bubble.size.type === "L" && (
                <Typography
                  style={{ color: COLORS.white, fontSize: 12, marginTop: 8 }}
                  align="center"
                >
                  {bubble[bubbleKey]}
                </Typography>
              )}
            </>
          )}
        </Grid>
      </Tooltip>
    </Box>
  );
};
